import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const RequiredValidator: (errorMessage: string) => FormValidator = (errorMessage: string) => {
  return async (value: any): Promise<ValidationResult> => {
    if (value === undefined || value === null || value === '' || (value instanceof Array && value.length === 0)) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    // disallow strings made out of whitespaces
    if (typeof value === 'string' && value.trim() === '') {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    return { valid: true };
  };
};
